import Home from '../assets/Home.svg'
import series from '../assets/TV Show.svg';
import MovieProjector from '../assets/Movie Projector.svg';
import calender from '../assets/Calendar.svg'

export const sideBarLinks= [
    {
        name:'Home',
        icon:Home
    },
    {
        name:'Movies',
        icon:MovieProjector
    },
    {
        name: 'TV series',
        icon: series
    },
    {
        name: 'Upcoming',
        icon: calender
    }
]